// Filename: collections/activitys
define('collections/template/assignments',[
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // Pull in the Model module from above
    'collections/member/profiles',
    'models/template/assignment',
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // services
    API,
    // super class
    InfiniteCollection,
    // model & collection
    CProfiles,
    MTemplateAssignment
) {

    var CTemplateAssignments = InfiniteCollection.extend({
        model: MTemplateAssignment,

        state: {
            pageSize: 25,
        },

        url: function() {
            var url = 'templates/assignments/';
            if (this.user) {
                url = Mustache.render('users/{{{userId}}}/templates/', {
                    userId: this.user
                });
            }

            if (this.template) {
                url = Mustache.render('templates/{{{templateId}}}/assignments/', {
                    templateId: this.template
                });
            }

            return API.url(url);
        },

        parse: function(data, opt) {
            if (data._users) this.usersCollection = new CProfiles(data._users);
            return CTemplateAssignments.__super__.parse.call(this, data, opt);
        },

        initialize: function(models, opt) {

        },

        onNewModel: function(model, opt) {
            if (this.usersCollection) {
                model.set('userDisplayName', this.usersCollection.get(model.get('user')).get('name'));
            }
        },

        setUser: function(userId) {
            this.user = userId;
            this.template = null;
            return this;
        },

        setTemplate: function(templateId) {
            this.template = templateId;
            this.user = null;
            return this;
        },

        getUser: function() {
            return this.user;
        },

        bulkDestroy: function(options) {
            options = _.extend({}, options, {
                url: _.result(this, 'url') + 'bulk_delete/',
            });
            return this.sync('patch', this, options);
        },

        bulkCreate: function(options) {
            options = _.extend({}, options, {
                url: _.result(this, 'url') + 'bulk_create/',
            });
            Backbone.sync("create", this, options);
        },

    });

    return CTemplateAssignments;
});

